var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectStatusRefused(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 17.5,
    rx: 12,
    ry: 12.5,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6067 0C8.66244 0 0.60683 8.05561 0.60683 17.9999C0.60683 22.471 2.22566 26.5565 4.92365 29.6786L0.414043 33.8029C-0.433916 34.5737 0.10566 36 1.262 36H18.6066C28.5509 36 36.6065 27.9444 36.6065 18.0001C36.6065 8.05589 28.5509 0.000275291 18.6066 0.000275291L18.6067 0ZM24.8894 21.8928C25.5446 22.548 25.5446 23.6272 24.8894 24.2824C24.5425 24.6292 24.1186 24.7836 23.6946 24.7836C23.2706 24.7836 22.8082 24.6295 22.4998 24.2824L18.6068 20.3896L14.7139 24.2826C14.3671 24.6294 13.9431 24.7838 13.5191 24.7838C13.0952 24.7838 12.6327 24.6297 12.3244 24.2826C11.6692 23.6274 11.6692 22.5482 12.3244 21.893L16.2172 17.9999L12.3242 14.1071C11.6689 13.4519 11.6689 12.3727 12.3242 11.7175C12.9794 11.0623 14.0585 11.0623 14.7138 11.7175L18.6066 15.6103L22.4995 11.7175C23.1547 11.0623 24.2339 11.0623 24.8891 11.7175C25.5443 12.3727 25.5443 13.4519 24.8891 14.1071L20.9965 17.9999L24.8894 21.8928Z",
    fill: "#FFE6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectStatusRefused);
export default __webpack_public_path__ + "static/media/connect-status-refused.95545aeb0772e23d5fee9d317a3a3bbe.svg";
export { ForwardRef as ReactComponent };